import NoteAltIcon from "@mui/icons-material/NoteAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Box } from "@mui/system";
import * as React from "react";
import { NavLink } from "react-router-dom";

export default function Nav() {
  const navData = [
    {
      name: "Driver Logs",
      icon: <NoteAltIcon />,
      linkTo: "/",
    },

    {
      name: "Live Tracking",
      icon: <VisibilityIcon />,
      linkTo: "/live-tracking",
    },
  ];

  return (
    <Box
      component={"nav"}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid",
        borderColor: "grey.300",
      }}
    >
      <List
        sx={{
          "& .MuiListItemButton-root": {
            width: 250,
          },
        }}
      >
        {navData.map((item) => (
          <NavLink key={item.name} to={item.linkTo}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.name} />
              </ListItemButton>
            </ListItem>
          </NavLink>
        ))}
      </List>
    </Box>
  );
}
